import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ErrorView } from '@americanexpress/commercial-ux-components';

type Props = {
  route: {
    sourceSystem?: string;
  };
};

const UnauthorizedError = ({ route: { sourceSystem } }: Props) => {
  const messageSuffix = sourceSystem !== undefined ? `.${sourceSystem}` : '';
  return (
    <ErrorView
      heading={<FormattedMessage id={`unauthorizedError.heading${messageSuffix}`} />}
      details={
        <span data-testid="error-details">
          <FormattedMessage
            id={`unauthorizedError.details${messageSuffix}`}
            values={{
              br: <br />,
              registeredTrademark: <sup>®</sup>,
            }}
          />
        </span>
      }
      actionButton={false}
    />
  );
};

export default UnauthorizedError;
